import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetMyTeams } from '@/shared/hooks/task/useGetMyTeams';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import MultiSelect, { splitItems } from '../multiselect/MultiSelect';
export const MyTeamsMultiSelect = ({ selectedItems, placeholder, onChange, }) => {
    const { formatMessage } = useIntl();
    const { data } = useGetMyTeams();
    const relationLabels = useMemo(() => data === null || data === void 0 ? void 0 : data.map(x => ({
        id: x.id,
        label: x.name,
        code: x.code.toString(),
        sort: x.name.toLowerCase(),
    })).sort(dynamicSort('sort')), [data]);
    const allLabels = useMemo(() => relationLabels && [
        { id: '0', label: formatMessage({ id: 'WithoutTeams' }), code: '0' },
        ...relationLabels,
    ], [formatMessage, relationLabels]);
    const [selectedLabels, availableLabels] = splitItems(allLabels, selectedItems, 'code');
    return (_jsx(MultiSelect, { selectedItem: selectedLabels, onItemRemoved: item => onChange(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(label => label !== item.value.code)), onItemSelected: item => onChange([...(selectedItems !== null && selectedItems !== void 0 ? selectedItems : []), item.code]), items: availableLabels, placeholder: placeholder }));
};
export const FilterMyTeamsMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(MyTeamsMultiSelect, { onChange: value => {
            var _a;
            setFilter({
                [item]: ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0 ? value : undefined,
            });
        }, selectedItems: activeFilters[item], placeholder: label })),
});
